<template>
  <v-app>
    <layout-main-drawer />
    <layout-main-app-bar />
    <v-main>
      <div class="px-4 w-100 h-100 d-flex justify-center align-center">
        <div class="error-message-block d-flex flex-column align-center">
          <v-icon icon="custom:ghostRun" :size="64" />
          <div class="error-heading my-4">Ups! Neatradām lapu, ko meklēji.</div>
          <div class="error-subtext">Lapa neeksistē vai tai ir mainīts nosaukums.</div>
          <v-btn rounded="pill" flat color="yellowActive" class="error-redirect-button mt-8" to="/">
            Uz sākumlapu
          </v-btn>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<style lang="sass">
.error-message-block
  max-width: 540px
  text-align: center
  .error-heading
    font-size: 40px
    font-weight: 700
    line-height: 130%
  .error-subtext
    font-size: 18px
    line-height: 26px
  .error-redirect-button
    max-width: 151px
    text-transform: none
    font-weight: 700
    font-size: 16px
    letter-spacing: 0.1px
    line-height: 20px
    .v-btn__content
      padding: 0px 50px
</style>
